/**
 * Compares two arrays for equality. Comparison of elements is shallow.
 * @param arr1 The first array to compare.
 * @param arr2 The second array to compare.
 * @returns True if the arrays are equal, false otherwise.
 */
export const arrayEquals = <T>(arr1: T[], arr2: T[]) => {
  if (arr1.length !== arr2.length) return false;

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }

  return true;
};
